import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getOfficeBrand = async () => {
  const { data } = await axios.get(`${api_base_url}/Common/OfficeBrand`);
  //const { data } = await axios.get("https://localhost:44399/api/OfficeBrand");
  return data;
};
//Insert New OfficeBrand
export const addOfficeBrand = async (newOfficeBrand) => {
  const { data } = await axios.post(`${api_base_url}/OfficeBrand`, {
    ...newOfficeBrand[0],
  });
  return data;
};
// Update OfficeBrand

export const updateOfficeBrand = async (updatedOfficeBrand) => {
  const { data } = await axios.put(
    `${api_base_url}/OfficeBrand/${updatedOfficeBrand[0].brandId}`,
    ...updatedOfficeBrand
  );
  return data;
};
//Search officeBrand
export const searchOfficeBrand = async (searchInputsData) => {
  const data = {
    brandName: searchInputsData.brandName,
  };
  return await axios
    .post(`${api_base_url}/OfficeBrand/SearchOfficeBrand`, data)
    .then((res) => res.data);
};

//Delete OfficeBrand by Id
export const deleteOfficeBrand = async (BrandId) => {
  await axios.delete(`${api_base_url}/OfficeBrand/${BrandId}`);
};
//

export const deleteOfficeBrands = async (BrandIds) => {
  await axios.delete(`${api_base_url}/OfficeBrand/delete`, {
    data: BrandIds,
  });
};
export const getOfficeBrandByOfficeBrandName = async (brandName) => {
  const { data } = await axios.get(`${api_base_url}/OfficeBrand/${brandName}`);
  //const { data } = await axios.get("https://localhost:44399/api/OfficeBrand");
  return data;
};
